import styled from "styled-components";
import { Body, MediumText } from "../Typography";

export const MarketingCarouselUserWrapper = styled.div`
    background: ${({ theme }) => theme ? theme.marketing.colors.blackPearl30 : null};
    border-radius: 4px;
    padding: 33px 0px;
`;

export const MarketingCarouselUserCard = styled.div`
    padding: 24px 18px;
`;

export const MarketingCarouselUserHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const MarketingCarouselUserTag = styled(MediumText)`
    color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl70 : null};
`;

export const MarketingCarouselUserImg = styled.img`
    width: 100%;
    max-width: 82px;
    height: auto;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
`;

export const MarketingCarouselUserBody = styled(Body)`
    color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
`;

export const MarketingCarouselUserSliderWrapper = styled.div`
    max-width: 2000px;
    margin: 0 auto;
    width: 100%;

    .swiper-slide {
        height: auto;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.13);
        border-radius: 4px;
        background: white;
    }
    
    .swiper {
        padding: 5px;
    }
`;